import { Component, input } from '@angular/core';
import { Activity } from '@mira-avant/mtlibs';
import { CommonModule } from '@angular/common';
import { CmsBadge } from "../cms-badge/cms-badge";

@Component({
	selector: 'app-rubric-level-summary',
	imports: [CommonModule, CmsBadge],
	standalone: true,
	templateUrl: './rubric-level-summary.html',
	styleUrl: './rubric-level-summary.scss',
})
export class RubricLevelSummary {
	activity = input.required<Activity>();
}
